import React from 'react';
import '../styles/Partnerships.css';
import { PageHeader } from '../components';

const Partnerships: React.FC = () => {
  return (
    <div className="partnerships">
      <PageHeader title="Partnerships" />
      <div className="partnerships-container">
        
        
        <div className="partnerships-content">
          <section className="partnerships-section">
            <h2>Strategic Collaboration for Long-term Growth</h2>
            <p>
              WTIL believes in strategic collaboration for long-term growth. Over the years, we've built strong partnerships with OEMs, technology providers, EPC firms, and industrial clients across India. Our partnerships are built on shared values of quality, innovation, and reliability.
            </p>
          </section>
          
          <section className="partnerships-section">
            <h2>Our Partnership Approach</h2>
            <p>
              Our approach to partnership is focused on:
            </p>
            <div className="approach-grid">
              <div className="approach-item">
                <h3>Technology Integration</h3>
                <p>Bringing the latest innovations to Indian markets through strategic technology partnerships.</p>
              </div>
              <div className="approach-item">
                <h3>Client-Centric Collaborations</h3>
                <p>Ensuring custom-fit solutions through focused client partnerships and collaborations.</p>
              </div>
              <div className="approach-item">
                <h3>Knowledge Sharing</h3>
                <p>Co-development and knowledge sharing initiatives for long-term mutual success.</p>
              </div>
              <div className="approach-item">
                <h3>Transparency & Commitment</h3>
                <p>Maintaining transparency and honoring commitments in all partnership agreements.</p>
              </div>
            </div>
          </section>
          
          <section className="partnerships-section">
            <h2>Partnership Categories</h2>
            <ul className="partnership-categories">
              <li>OEMs (Original Equipment Manufacturers)</li>
              <li>Technology Providers</li>
              <li>EPC Firms (Engineering, Procurement, and Construction)</li>
              <li>Industrial Clients across India</li>
              <li>Water Treatment Solution Providers</li>
              <li>Supply Chain Partners</li>
              <li>Regional Collaboration Partners</li>
            </ul>
          </section>
          
          <section className="partnerships-section partnership-cta">
            <h2>Partner With Us</h2>
            <p>
              If you're looking to partner with us in water treatment solutions, supply chains, or regional collaboration, we'd love to hear from you.
            </p>
            <div className="cta-content">
              <p>
                Join our network of trusted partners and together, let's create innovative solutions for India's water treatment challenges.
              </p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Partnerships;
